module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0012-0b46ab32b68b85a7b6fd5e75fe3667a1.jpg";